export * from './inside-platform/InsidePlatform';
export * from './outside-platform/OutsidePlatform';
export * from './data-company/DataCompany';
export * from './modal-political-data/ModalPoliticalData';
export * from './modal-terms-conditions/ModalTermsConditions';
export * from './modal-wait-response/ModalWaitResponse';
export * from './modal-reject-response/ModalRejectResponse';
export * from './remembrance/Remembrance';
